import { useRef } from "react";
import ClearIcon from "@src/components/ClearIcon/ClearIcon";
import "./styles/input.sass";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
    name: string;
    ariaHidden?: boolean;
    displayClearButton?: boolean;
    onClick?: () => void;
    clearSideEffect?: () => void;
    register?: any;
    label?: string;
}

const Input = ({
    type = "text",
    name,
    displayClearButton = false,
    ariaHidden = false,
    onClick = () => { },
    register = () => { },
    clearSideEffect = () => { },
    label,
    ...rest
}: IProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const clearInput = () => {
        inputRef.current!.value = "";
        inputRef.current!.focus();
    };
    const { ref, ...regRest } = register(name);
    return (
        <div style={{ display: "relative" }}>
            <input
                ref={(e: HTMLInputElement) => {
                    ref(e);

                    //@ts-ignore
                    inputRef.current = e;
                }}
                onClick={onClick}
                type={type}
                name={name}
                aria-labelledby={`${name}-label`}
                className={`input__input ${type == "checkbox" ? "input-hidden" : ""
                    }`}
                id={name}
                aria-hidden={ariaHidden}
                {...regRest}
                {...rest}
            />
            {displayClearButton && (
                <button
                    type="button"
                    title="Clear"
                    className="input__clear"
                    onClick={() => {
                        clearInput();
                        clearSideEffect();
                    }}
                    name="input_clear"
                >
                    <ClearIcon />
                </button>
            )}
            {type == "checkbox" && (
                <div className="checkbox-ui">
                    <button
                        type="button"
                        className="checkbox-span"
                        data-testid="checkbox-span"
                        onClick={() => {
                            inputRef.current!.checked =
                                !inputRef.current!.checked;
                            regRest.onChange({
                                type: "change",
                                target: {
                                    name: name,
                                    value: inputRef.current?.checked,
                                },
                            });
                        }}
                        title={`Toggle ${name}`}
                    ></button>

                    <label
                        htmlFor={name}
                        onClick={(e) => {
                            e.preventDefault();
                            inputRef.current!.checked =
                                !inputRef.current!.checked;
                            regRest.onChange({
                                type: "change",
                                target: {
                                    name: name,
                                    value: inputRef.current?.checked,
                                },
                            });
                        }}
                    >
                        {label && label}
                    </label>
                </div>
            )}
        </div>
    );
};
export default Input;
